import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'
import {MachineSentryActionDto} from '../../../types'

export const MachineSentryActionQueryKey = 'machine-sentry-action'

const INTERVAL_PERIOD_IN_MS = 30_000

type Params = {
  plantUpmId?: string
  externalId: string
}

export const useMachineSentryAction = (
  {plantUpmId, externalId}: Params,
  options?: UseQueryOptions<MachineSentryActionDto, AxiosError>
) => {
  const path = `${TasksApiPath.MACHINE_SENTRY_ACTIONS}/${plantUpmId}/machine-sentry-actions/${externalId}`

  return useQuery<MachineSentryActionDto, AxiosError>({
    queryKey: [MachineSentryActionQueryKey, externalId, plantUpmId],
    queryFn: async ({signal}) => {
      const {data} = await ApiClient.axiosInstance.get<MachineSentryActionDto>(path, {signal})

      return data
    },
    refetchInterval: INTERVAL_PERIOD_IN_MS,
    enabled: !!plantUpmId,
    ...options
  })
}
